<script setup>
definePage({
  name: 'shipment-warehouse-cotation-index',
  meta: {
    requiresAuth: true,
    action: 'read',
    subject: 'Parcels',
  },
})

// Sidebar entry: pick a container, then open its Cotation.
import ContainerPicker from '@/components/shipment/ContainerPicker.vue'
</script>

<template>
  <ContainerPicker
    title="Cotation"
    base-path="/shipment/warehouse/cotation"
    icon="tabler-calculator"
  />
</template>
